export enum PaymentMethod {
    CARD = 0,
    SWISH = 1,
    VIPPS = 2,
    GIFT_CARD = 4
}